export default {
      id: "sli-search-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-search",
      toString: function () {
        return this.url;
      }
    }